import type { DetectionRegion, RedactionMode } from '../types'
import { piiCategoryLabel } from '../core/pii'

interface Props {
  regions: DetectionRegion[]
  selectedId?: string
  defaultMode: RedactionMode
  onSelect: (id?: string) => void
  onChange: (regions: DetectionRegion[]) => void
}

const modes: Array<{ value: RedactionMode; label: string }> = [
  { value: 'solid', label: '黒塗り' },
  { value: 'mosaic', label: 'モザイク' },
  { value: 'blur', label: 'ぼかし' },
  { value: 'fill', label: '色' },
]

export function RegionList({ regions, selectedId, defaultMode, onSelect, onChange }: Props) {
  const update = (id: string, patch: Partial<DetectionRegion>) => onChange(regions.map((region) => region.id === id ? { ...region, ...patch } : region))
  const remove = (id: string) => onChange(regions.filter((region) => region.id !== id))
  const enabledCount = regions.filter((region) => region.enabled).length

  return (
    <section className="region-panel" aria-labelledby="region-title">
      <div className="panel-heading">
        <div><span>見つけた場所</span><h2 id="region-title">{enabledCount}か所を隠す</h2></div>
        <small>押すと画像上の場所が選ばれます</small>
      </div>

      {regions.length === 0 ? (
        <div className="empty-panel"><strong>自動では見つかりませんでした</strong><span>画像を見て、「隠す場所を追加」から必要な場所を囲ってください。</span></div>
      ) : (
        <ol className="region-list">
          {regions.map((region, index) => {
            const selected = region.id === selectedId
            return (
              <li key={region.id} className={selected ? 'selected' : ''}>
                <div className="region-row">
                  <button className="region-select" type="button" onClick={() => onSelect(region.id)}>
                    <span className={`region-number category-${region.category}`}>{index + 1}</span>
                    <span className="region-copy">
                      <strong>{piiCategoryLabel(region.category)}</strong>
                      <small>{region.source === 'manual' ? '自分で追加しました' : '自動で見つけました'}</small>
                    </span>
                  </button>
                  <button type="button" className={`region-visibility ${region.enabled ? 'is-on' : ''}`} aria-pressed={region.enabled} onClick={() => update(region.id, { enabled: !region.enabled })}>{region.enabled ? '隠す' : '隠さない'}</button>
                </div>
                {region.warning && <p className="region-warning">{region.warning}</p>}
                {selected && (
                  <div className="region-detail">
                    <span>この場所の隠し方</span>
                    <div className="region-mode-tabs">
                      {modes.map((mode) => (
                        <label key={mode.value} className={(region.mode ?? defaultMode) === mode.value ? 'selected' : ''}>
                          <input type="radio" name={`mode-${region.id}`} checked={(region.mode ?? defaultMode) === mode.value} onChange={() => update(region.id, { mode: mode.value })} />
                          <span>{mode.label}</span>
                        </label>
                      ))}
                    </div>
                    <button type="button" className="region-delete" onClick={() => remove(region.id)}>この場所を削除</button>
                  </div>
                )}
              </li>
            )
          })}
        </ol>
      )}
    </section>
  )
}
